import {
  isAmenityKeyRestricted,
  type AmenityRestrictionCheckSource,
} from "@/src/modules/households/lib/household-amenity-restriction";
import {
  formatRestrictedAmenityKeys,
  RESTRICTED_AMENITY_KEYS,
  type RestrictedAmenityKey,
} from "@/src/modules/households/lib/restrictable-amenities";

const FACILITY_AMENITY_KEYS = ["pool", "tennis", "gym", "recreation"] as const satisfies readonly RestrictedAmenityKey[];

export const RESIDENT_SAFELISTING_RESTRICTION_MESSAGE =
  "Existing safelistings may not protect your vehicles from citations.";

export const RESIDENT_PERMANENT_PARKING_RESTRICTION_MESSAGE =
  "Your vehicles may be cited even if a permit is listed below.";

export const RESIDENT_GENERIC_AMENITY_RESTRICTION_MESSAGE =
  "Amenity access is restricted for this household.";

export function getBlockedFacilityAmenityKeys(
  household: AmenityRestrictionCheckSource | null | undefined,
): RestrictedAmenityKey[] {
  if (!household) return [];
  return FACILITY_AMENITY_KEYS.filter((key) => isAmenityKeyRestricted(household, key));
}

export function hasAnyHouseholdAmenityRestriction(
  household: AmenityRestrictionCheckSource | null | undefined,
): boolean {
  if (!household) return false;
  return RESTRICTED_AMENITY_KEYS.some((key) => isAmenityKeyRestricted(household, key));
}

export function getResidentFacilitiesRestrictionMessage(
  household: AmenityRestrictionCheckSource | null | undefined,
): string | null {
  const blocked = getBlockedFacilityAmenityKeys(household);
  if (blocked.length === 0) return null;
  const labels = formatRestrictedAmenityKeys(blocked);
  return `${labels} access is suspended for your household.`;
}

export function isFacilityAmenityTypeRestricted(
  household: AmenityRestrictionCheckSource | null | undefined,
  amenityType: string,
): boolean {
  if (!FACILITY_AMENITY_KEYS.includes(amenityType as (typeof FACILITY_AMENITY_KEYS)[number])) {
    return false;
  }
  return isAmenityKeyRestricted(household, amenityType as RestrictedAmenityKey);
}
